import styled from 'foundations-theming/utils';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';

/**
 * Repaints the CloseButton's hover circle (its `::after`) accent blue. Our fill
 * is opaque, so `z-index: -1` tucks the circle behind the "X" instead of over it.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const OnFillHover = styled.div.withConfig({
  displayName: "OnFillCloseButton__OnFillHover"
})(["display:inline-flex;[data-action='close']:hover::after{background-color:", ";z-index:-1;}"], ({
  theme
}) => theme.color['fill-accent-blue-hover']);
/**
 * A close button intended to sit on a filled (accent-colored) surface: a white
 * "X" with a circular `fill-accent-blue-hover` hover state.
 */
const OnFillCloseButton = ({
  'aria-label': ariaLabel,
  onClick,
  'data-test-id': dataTestId
}) => /*#__PURE__*/_jsx(OnFillHover, {
  children: /*#__PURE__*/_jsx(CloseButton, {
    "aria-label": ariaLabel,
    color: "icon-core-on-fill-default",
    "data-test-id": dataTestId,
    inline: true,
    onClick: onClick,
    size: "md"
  })
});
export default OnFillCloseButton;